import React from "react";
import Card from "../Card/Card";

const data = [
  {
    document: "POBALINES",
    year: '2026',
    //title: 'Políticas, Bases y Lineamientos',
    link: '/CAASIM/POBALINES/POBALINES CAASIM 2026.pdf'
  },
  
];

function POBALINES() {
  return (
    <div className="container py-4">
      <div className="secretaria_funciones">
        <h3 className="title text-uppercase">POBALINES</h3>
        <hr className="hr-gob" />
      </div>
      <div>
        <h4 className="title">Objetivo</h4>
        <p className="mb-4">Las presentes Políticas, Bases y Lineamientos para la Administración de los Recursos Humanos al Servicio de la Comisión de Agua y Alcantarillado de Sistemas Intermunicipales tienen por objeto regular la administración, organización, supervisión, profesionalización, capacitación, control, disciplina, seguridad y demás aspectos inherentes a la gestión de los recursos humanos, así como establecer los derechos, obligaciones, responsabilidades y mecanismos de actuación de las personas servidoras públicas adscritas a las distintas Unidades Administrativas de la Comisión, en estricto apego a las disposiciones jurídicas, administrativas y laborales aplicables.</p>
      </div>
      <div className="row">
        {data.map((item, index) => (
          <Card
            key={index}
            document={item.document}
            title={item.title}
            href={item.link}
            year={item.year}
            type={"PDF"}
          />
        ))}
      </div>
    </div>
  );
}

export default POBALINES;
